export const environment = {
  production: false,
  host: 'http://localhost:4200'
}
